export default Backbone.Model.extend({
  defaults: {
    zoomlevel: null,
    centerlat: null,
    centerlng: null,
    minlat: null,
    minlng: null,
    maxlat: null,
    maxlng: null,
  },

  boundsSameAs(data) {
    // Returns true if the lat/lng values are the same
    // as the ones in the query object
    const self = this;
    return _.every(
      ['minlat', 'minlng', 'maxlat', 'maxlng'],
      attr => self.get(attr) === parseFloat(data[attr])
    );
  },
});



// WEBPACK FOOTER //
// ./js/backbone/models/search/map_search_data.js